import React, { Component } from "react";
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import Box from '../ui/Box';

//services
import { store } from '../../stores/configureStore';
import { push } from 'react-router-redux'
import DataService from '../../services/DataService'; var ds = DataService;

export default class FeedbackTemplateList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      templatesList: []
    };
  }

  componentDidMount() {
    this.getFeedbackTemplates();
  }

  getFeedbackTemplates() {
    ds.getFeedbackTemplates(
      data => {
        this.setState({
          templatesList: data
        })
      }, err => {}
    )
  }

  viewResponses(template, e) {
    ds.getFeedBackResponses(template._id, 10, 0,
      data => {
        console.log('in data = ', data);
        store.dispatch(push(`/app/feedback/template/responses/${template._id}`));
      },
      err => {
        console.log('in error = ', err);
      }
    );
  }

  editTemplate() {}

  deleteTemplate () {}

  render() {
    return (
      <div>
        <Box header='All Feedback Templates in the Hotel'>
          <Table
            height={'45vh'}
            fixedHeader={true}
            fixedFooter={true}
            selectable={false}
            multiSelectable={false}
            style={{ minWidth: 700 }}
            bodyStyle={{ minWidth: 700, overflowX: 'auto' }}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Title">Title</TableHeaderColumn>
                <TableHeaderColumn tooltip="Description">Description</TableHeaderColumn>
                <TableHeaderColumn tooltip="Survey Questions">Survey Questions</TableHeaderColumn>
                <TableHeaderColumn tooltip="Survey Responses">Response(s)</TableHeaderColumn>
                {/* <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn> */}
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.templatesList && this.state.templatesList.length ? this.state.templatesList.map((row, index) => (
                    <TableRow key={index}>
                      <TableRowColumn>{row.title}</TableRowColumn>

                      <TableRowColumn style={{ whiteSpace: "normal" }}>
                        {row.description}
                      </TableRowColumn>

                      <TableRowColumn>
                        {
                          row.survey_sections && row.survey_sections[0].questions && row.survey_sections[0].questions.length ?
                            row.survey_sections[0].questions.map(que => {
                              return (
                                <p style={{fontSize: '12px', fontWeight: '300', marginBottom: '0px'}}>• {que.title}</p>
                              )
                            }) 
                          : 'No Questions'
                        }
                      </TableRowColumn>

                      <TableRowColumn>
                        <i className="material-icons"
                          style={{ cursor:'pointer', color: 'rgb(58, 188, 212)' }}
                          onClick={this.viewResponses.bind(this, row)}
                        >
                          visibility
                        </i>
                      </TableRowColumn>

                      {/* <TableHeaderColumn className="v-center">
                        <i className="material-icons link-fg"
                          style={{cursor:'pointer'}}
                          onClick={this.editTemplate.bind(this, row)}
                        >
                          mode_edit
                        </i>

                        <i className="space"></i>

                        <i className="material-icons warn-fg"
                          style={{cursor:'pointer'}}
                          onClick={this.deleteTemplate.bind(this, row)}
                        >
                          delete
                        </i>
                      </TableHeaderColumn> */}
                    </TableRow>
                  ))
                : null
              }
            </TableBody>
          </Table>
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/feedback/FeedbackTemplateList.js